// export default IncidentRequest;
import React, { useState } from "react";
import BackButton from "components/BackButton";
import SuspectToWitnessList from "./SuspectToWitnessList";
import SuspectToWitnessDetail from "./SuspectToWitnessDetail";

type Props = {
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const SuspectToWitnessTab: React.FC<Props> = ({
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  const [pageType, setPageType] = useState<"list" | "detail">("list");
  const [selectedId, setSelectedId] = useState<string | number>("");

  return (
    <div>
      {pageType === "list" ? (
        <SuspectToWitnessList
          crimeReferenceNumber={crimeReferenceNumber}
          incidentRegistrationNumber={incidentRegistrationNumber}
          setSelectedId={setSelectedId}
          setPageType={setPageType}
        />
      ) : (
        <div>
          <div>
            <BackButton onClick={() => setPageType("list")} />
            <SuspectToWitnessDetail selectedId={selectedId} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SuspectToWitnessTab;
